import { createContext } from "react";
import { FormInstance } from "antd/lib/form";

export default createContext<FormInstance<any> | undefined>(
  undefined,
);